import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "features", "onClickFeature", "active"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { concatClassNames as r, accessibleOnClick as m } from "@sys42/utils";
import { useWebsiteNavigate as _ } from "../../hooks/useWebsiteNavigate.js";
import { FeatureIcon as v } from "../FeatureIcon/index.js";
import { WebsiteLink as d } from "../WebsiteLink/index.js";
import '../../assets/index28.css';
var I = "_featureOverviewCompact_1fptt_1",
  T = "_featuresItem_1fptt_4",
  w = "_featuresDescription_1fptt_17",
  C = "_featuresTitle_1fptt_21",
  N = "_featuresTitle_active_1fptt_46",
  b = "_featuresIcon_1fptt_50",
  s = {
    featureOverviewCompact: I,
    featuresItem: T,
    featuresDescription: w,
    featuresTitle: C,
    featuresTitle_active: N,
    featuresIcon: b
  };
function k(i) {
  var c = i.className,
    o = i.features,
    a = i.onClickFeature,
    f = i.active,
    n = _objectWithoutProperties(i, _excluded),
    u = _("website");
  return /* @__PURE__ */t("div", _objectSpread(_objectSpread({
    className: r(c, s.featureOverviewCompact)
  }, n), {}, {
    children: o.map(function (e, p) {
      return /* @__PURE__ */l("div", _objectSpread(_objectSpread({
        className: s.featuresItem
      }, m(function () {
        u(e.to), typeof a == "function" && a();
      })), {}, {
        children: [/* @__PURE__ */t(v, {
          className: s.featuresIcon,
          children: /* @__PURE__ */t("img", {
            src: e.image,
            alt: e.alt
          })
        }), /* @__PURE__ */t(d, {
          websiteType: "website",
          to: e.to,
          className: r(s.featuresTitle, e.to.split("/").pop() === f && s.featuresTitle_active),
          tabIndex: -1,
          children: /* @__PURE__ */t("span", {
            children: e.title
          })
        }), /* @__PURE__ */t("div", {
          className: s.featuresDescription,
          children: e.description
        })]
      }), p);
    })
  }));
}
export { k as FeatureOverviewCompact };